import classNames from 'classnames';
import React, { CSSProperties } from 'react';
import { body } from '../Styles/Colours';
import styles from './StyledIcon.module.scss';

export type IconSizes = '96' | '80' | '64' | '56' | '48' | '40' | '32' | '24' | '20' | '18' | '16' | '12';

export interface IconProps {
    style?: {};
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
    className?: string;
    size?: IconSizes;
    borderColour?: string;
    backgroundColour?: string;
    color?: string;
    noSizing?: boolean;
    noPadding?: boolean;
    noCircularContainer?: boolean;
    testId?: string;
}

export class StyledIcon extends React.Component<IconProps> {
    public static getIconSize(sizeClass?: IconSizes): {
        size: number;
        padding: number;
    } {
        switch (sizeClass) {
            case '96':
                return {
                    size: 96,
                    padding: 20
                };
            case '80':
                return {
                    size: 80,
                    padding: 17
                };
            case '64':
                return {
                    size: 64,
                    padding: 14
                };
            case '56':
                return {
                    size: 56,
                    padding: 17
                };
            case '48':
                return {
                    size: 48,
                    padding: 10
                };
            case '40':
                return {
                    size: 40,
                    padding: 8
                };
            case '32':
                return {
                    size: 32,
                    padding: 6
                };
            case '20':
                return {
                    size: 20,
                    padding: 2
                };
            case '18':
                return {
                    size: 18,
                    padding: 2
                };
            case '16':
                return {
                    size: 16,
                    padding: 0
                };
            case '12':
                return {
                    size: 12,
                    padding: 0
                };
            case '24':
            default:
                return {
                    size: 24,
                    padding: 2
                };
        }
    }

    public render() {
        const sizeValue = StyledIcon.getIconSize(this.props.size);

        const iconBaseStyle: CSSProperties = this.props.noSizing
            ? {}
            : {
                  minHeight: sizeValue.size,
                  height: sizeValue.size,
                  maxHeight: sizeValue.size,
                  minWidth: sizeValue.size,
                  width: sizeValue.size,
                  maxWidth: sizeValue.size,
                  backgroundColor: this.props.backgroundColour,
                  display: 'inline-flex'
              };

        if (!this.props.noPadding)
            iconBaseStyle.padding = !this.props.borderColour ? sizeValue.padding : sizeValue.padding - 1;

        if (this.props.borderColour) iconBaseStyle.border = `1px solid ${this.props.borderColour}`;

        const iconStyles = this.props.style ? { ...iconBaseStyle, ...this.props.style } : iconBaseStyle;

        const iconClasses = classNames(
            this.props.className,
            {
                [styles.mouseHover]: !!this.props.onClick,
                [styles.noCircularContainer]: this.props.noCircularContainer
            },
            styles.icon
        );

        // THESE MUST HAVE A ROOT ELEMENT OF SPAN
        // It's important for the tagging system in rooster that there are no divs in the dom structure.
        return (
            <span
                className={iconClasses}
                style={iconStyles}
                onClick={this.props.onClick}
                data-test-id={this.props.testId}
            >
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='100%'
                    height='100%'
                    fill={this.props.color ?? body}
                    viewBox='0 0 24 24'
                    focusable='false'
                >
                    <g>{this.props.children}</g>
                </svg>
            </span>
        );
    }
}
